export default "__VITE_ASSET__pcmC6r_c__"